(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["global-tooltip"] && !Shopify.designMode) return;
  try {
    /**
   * Global tooltip: single shared tooltip DOM node, shown when hovering/focusing
   * or tapping elements with [data-tooltip]. Arrow points at the trigger element.
   * All functions/vars below are inside an IIFE (init), so they are private and
   * cannot conflict with other theme scripts (handlePointerEnter, handleFocus, etc.).
   */
  const tooltipHostSelector = '.global-tooltip-host';
  const tooltipAttribute = 'data-tooltip';
  const activeAttribute = 'data-tooltip-active';

  const VIEWPORT_EDGE = 8;
  const ARROW_SIZE = 10;
  const ARROW_OFFSET = 4;

  function createTooltipRoot() {
    const host = document.querySelector(tooltipHostSelector);
    if (!host) return null;

    const tooltip = document.createElement('div');
    tooltip.className = 'global-tooltip';
    tooltip.setAttribute('role', 'tooltip');

    const inner = document.createElement('div');
    inner.className = 'global-tooltip__inner';

    const arrow = document.createElement('div');
    arrow.className = 'global-tooltip__arrow';

    tooltip.appendChild(inner);
    tooltip.appendChild(arrow);
    host.appendChild(tooltip);

    return { host, tooltip, inner, arrow };
  }

  function getTooltipRoot(rootRef) {
    if (rootRef.current) return rootRef.current;
    rootRef.current = createTooltipRoot();
    return rootRef.current;
  }

  /**
   * Position tooltip near the target, clamp to viewport, then position arrow
   * so it points at the target. Arrow is above or below bubble depending on space.
   */
  function showTooltip(rootRef, target, content) {
    const root = getTooltipRoot(rootRef);
    if (!root || !content) return;

    const { tooltip, inner, arrow } = root;

    inner.textContent = '';
    inner.appendChild(document.createTextNode(content));

    const rect = target.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    const vw = document.documentElement.clientWidth;
    const vh = document.documentElement.clientHeight;

    let top = rect.top - tooltipRect.height - VIEWPORT_EDGE;
    let left = rect.left + rect.width / 2 - tooltipRect.width / 2;

    if (top < VIEWPORT_EDGE) {
      top = rect.bottom + VIEWPORT_EDGE;
    }
    if (left < VIEWPORT_EDGE) {
      left = VIEWPORT_EDGE;
    } else if (left + tooltipRect.width > vw - VIEWPORT_EDGE) {
      left = vw - tooltipRect.width - VIEWPORT_EDGE;
    }
    if (top + tooltipRect.height > vh - VIEWPORT_EDGE) {
      top = vh - tooltipRect.height - VIEWPORT_EDGE;
    }

    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;

    const isAboveTarget = top + tooltipRect.height < rect.top;
    const targetCenterX = rect.left + rect.width / 2;
    let arrowLeftPx = targetCenterX - left;
    arrowLeftPx = Math.max(ARROW_OFFSET, Math.min(tooltipRect.width - ARROW_OFFSET, arrowLeftPx));

    arrow.style.display = 'block';
    arrow.style.width = ARROW_SIZE + 'px';
    arrow.style.height = ARROW_SIZE + 'px';
    arrow.style.left = arrowLeftPx + 'px';
    arrow.style.transform = isAboveTarget ? 'translate(-50%,0) rotate(225deg)' : 'translate(-50%,0) rotate(45deg)';
    arrow.style.top = isAboveTarget ? '' : '-' + ARROW_OFFSET + 'px';
    arrow.style.bottom = isAboveTarget ? '-' + ARROW_OFFSET + 'px' : '';
    arrow.classList.remove('global-tooltip__arrow--top', 'global-tooltip__arrow--bottom');
    arrow.classList.add(isAboveTarget ? 'global-tooltip__arrow--bottom' : 'global-tooltip__arrow--top');

    tooltip.classList.add('global-tooltip--visible');
    target.setAttribute(activeAttribute, 'true');
  }

  function hideTooltip(rootRef, target) {
    const root = rootRef.current;
    if (!root) return;
    root.tooltip.classList.remove('global-tooltip--visible');
    if (target) target.removeAttribute(activeAttribute);
  }

  (function init() {
    const state = { currentTarget: null, openedBy: null, lastTouchShow: null };
    const rootRef = { current: null };
    const OPENED_BY_POINTER = 'pointer';
    const OPENED_BY_FOCUS = 'focus';
    const SAME_TAP_MS = 400;

    function getContentFromTarget(el) {
      if (!el) return '';
      const attr = el.getAttribute(tooltipAttribute);
      return attr && attr.trim() ? attr.trim() : '';
    }

    function isPointInRect(x, y, rect) {
      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    }

    function findTooltipTarget(el, ev) {
      if (!el) return null;
      if (el.hasAttribute && el.hasAttribute(tooltipAttribute)) return el;
      const ancestor = el.closest && el.closest('[' + tooltipAttribute + ']');
      if (ancestor) return ancestor;
      const descendant = el.querySelector && el.querySelector('[' + tooltipAttribute + ']');
      if (descendant && ev && ev.clientX != null) {
        const rect = descendant.getBoundingClientRect();
        if (isPointInRect(ev.clientX, ev.clientY, rect)) return descendant;
      }
      return null;
    }

    function closeTooltip() {
      if (!state.currentTarget) return;
      state.lastTouchShow = null;
      hideTooltip(rootRef, state.currentTarget);
      state.currentTarget = null;
      state.openedBy = null;
    }

    function handlePointerEnter(e) {
      const target = findTooltipTarget(e.target, e);
      if (!target) return;
      const content = getContentFromTarget(target);
      if (!content) return;
      state.currentTarget = target;
      state.openedBy = OPENED_BY_POINTER;
      showTooltip(rootRef, target, content);
    }

    function handlePointerLeave(e) {
      if (!state.currentTarget) return;
      if (e.relatedTarget && state.currentTarget.contains(e.relatedTarget)) return;
      closeTooltip();
    }

    function handleFocus(e) {
      const target = findTooltipTarget(e.target, e);
      if (!target) return;
      const content = getContentFromTarget(target);
      if (!content) return;
      state.currentTarget = target;
      state.openedBy = OPENED_BY_FOCUS;
      showTooltip(rootRef, target, content);
    }

    function handleBlur() {
      if (!state.currentTarget) return;
      if (state.openedBy === OPENED_BY_POINTER) return;
      closeTooltip();
    }

    function handleTouchEnd(e) {
      const target = findTooltipTarget(e.target, e);
      if (!target || target.getAttribute(activeAttribute) === 'true') return;
      const content = getContentFromTarget(target);
      if (!content) return;
      state.currentTarget = target;
      state.openedBy = OPENED_BY_POINTER;
      state.lastTouchShow = { target: target, time: Date.now() };
      showTooltip(rootRef, target, content);
    }

    function handleClick(e) {
      const target = findTooltipTarget(e.target, e);
      if (!target) return;
      const isActive = target.getAttribute(activeAttribute) === 'true';
      if (isActive) {
        if (
          state.lastTouchShow &&
          state.lastTouchShow.target === target &&
          Date.now() - state.lastTouchShow.time < SAME_TAP_MS
        ) {
          state.lastTouchShow = null;
          return;
        }
        closeTooltip();
        return;
      }
      state.lastTouchShow = null;
      const content = getContentFromTarget(target);
      if (!content) return;
      state.currentTarget = target;
      state.openedBy = OPENED_BY_POINTER;
      showTooltip(rootRef, target, content);
    }

    function handleDocumentClick(e) {
      if (!state.currentTarget) return;
      if (findTooltipTarget(e.target)) return;
      closeTooltip();
    }

    function handleScroll() {
      if (state.currentTarget) closeTooltip();
    }

    function handleKeydown(e) {
      if (e.key === 'Escape') closeTooltip();
    }

    /* Desktop: hover + keyboard. Mobile: touchend opens, click toggles/close. Scroll/click-outside/Escape close. */
    document.addEventListener('mouseenter', handlePointerEnter, true);
    document.addEventListener('mouseleave', handlePointerLeave, true);
    document.addEventListener('focusin', handleFocus);
    document.addEventListener('focusout', handleBlur);
    document.addEventListener('touchend', handleTouchEnd, { passive: true });
    document.addEventListener('click', handleClick);
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('scroll', handleScroll, { passive: true, capture: true });
    document.addEventListener('keydown', handleKeydown);
  })();
  } catch(e) { console.error(e); }
})();

})();
